import { createStore, withProps, select } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { persistState, localStorageStrategy } from '@ngneat/elf-persist-state';
import { Injectable } from '@angular/core';
import { IUserData } from '../../../shared/models/auth/user';
import { ITokenData } from '../../../shared/models/auth/token';
import { RoleList } from '../../../shared/models/profiles/role';
import { BaseRepository } from '@core/state/base.repository';
import { BusyService } from '@core/services/busy.service';

interface IAuthState {
  // user: IUserData | null;
  token: ITokenData | null;
  loggingOut: boolean;
  loading: boolean;
}

const initialState: IAuthState = {
  token: null, 
  loggingOut: false,
  loading: false
};

// initialize a store with a state
const authStore = createStore(
  { name: 'auth' },
  withProps<IAuthState>(initialState)
);

export const authPersist = persistState(authStore, {
  key: 'auth',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class AuthRepository extends BaseRepository<IAuthState> {
  constructor() {
    super('auth', initialState);
  }

  token$: Observable<ITokenData | null> = authStore.pipe(
    select((state) => state.token)
  );

  loggingOut$: Observable<boolean | null> = authStore.pipe(
    select((state) => state.loggingOut)
  );

  loading$: Observable<boolean> = authStore.pipe(
    select((state) => state.loading)
  );

  setLoading(loading: boolean): void {
    authStore.update((state) => ({ ...state, loading }));
  }

  updateToken(token: IAuthState['token']) {
    authStore.update((state) => ({
      ...state,
      token,
    }));
  }

  setLoggingOut(loggingOut: IAuthState['loggingOut']) {
    authStore.update((state) => ({
      ...state,
      loggingOut,
    }));
  }
}
